/**
 * blur 선택 하이라이트 (P9-⑥) — CSS Custom Highlight API 로 포커스가 빠져도 선택 범위를
 * 계속 보이게 한다(미지원 환경은 무시). editorEl 에 focusin/focusout 리스너를 자체 부착한다.
 *
 *   const hl = createBlurHighlight(editorEl);
 *   // selectionchange 시 hl.capture()
 *   hl.destroy(); // 정리
 */
export function createBlurHighlight(editorEl) {
  const HL_NAME = 'lumir-blur-sel';
  const hlSupported =
    typeof CSS !== 'undefined' &&
    CSS.highlights &&
    typeof Highlight !== 'undefined';
  if (
    hlSupported &&
    typeof document !== 'undefined' &&
    document.head &&
    !document.getElementById('lumir-blur-sel-style')
  ) {
    try {
      const st = document.createElement('style');
      st.id = 'lumir-blur-sel-style';
      st.textContent =
        '::highlight(lumir-blur-sel){background:rgba(91,87,214,0.28);}';
      document.head.appendChild(st);
    } catch (_) {}
  }
  let lastSelRange = null;
  function capture() {
    const sel = document.getSelection();
    if (sel && sel.rangeCount) {
      const r = sel.getRangeAt(0);
      if (!r.collapsed) {
        let n = r.startContainer;
        if (n && n.nodeType === 3) n = n.parentNode;
        const c = n && n.closest ? n.closest('.content, td.lumir-cell') : null;
        if (c && editorEl.contains(c)) {
          lastSelRange = r.cloneRange();
          return;
        }
      }
    }
    lastSelRange = null;
  }
  function show() {
    if (hlSupported && lastSelRange) {
      try {
        CSS.highlights.set(HL_NAME, new Highlight(lastSelRange));
      } catch (_) {}
    }
  }
  function clear() {
    if (hlSupported) {
      try {
        CSS.highlights.delete(HL_NAME);
      } catch (_) {}
    }
  }
  const onFocusIn = () => clear();
  const onFocusOut = (e) => {
    if (!editorEl.contains(e.relatedTarget)) show();
  };
  editorEl.addEventListener('focusin', onFocusIn);
  editorEl.addEventListener('focusout', onFocusOut);

  function destroy() {
    clear();
    editorEl.removeEventListener('focusin', onFocusIn);
    editorEl.removeEventListener('focusout', onFocusOut);
  }

  return { capture, clear, destroy };
}
